export interface StateCity {
  name: string;
  slug: string;
  population: string;
  hasCalculator: boolean;
}

export interface USStateData {
  name: string;
  abbreviation: string;
  slug: string;
  region: string;
  capital: string;
  population: string;
  stateTaxType: string;
  topRate: string;
  cities: StateCity[];
  imageQuery: string;
}

export const usRegions = [
  "All",
  "Northeast",
  "Southeast",
  "Midwest",
  "Southwest",
  "West",
  "Pacific",
];

export const usStatesData: USStateData[] = [
  {
    name: "Alabama",
    abbreviation: "AL",
    slug: "al",
    region: "Southeast",
    capital: "Montgomery",
    population: "5.1M",
    stateTaxType: "Graduated",
    topRate: "5.0%",
    cities: [
      { name: "Birmingham", slug: "birmingham", population: "197K", hasCalculator: false },
      { name: "Huntsville", slug: "huntsville", population: "216K", hasCalculator: false },
      { name: "Montgomery", slug: "montgomery", population: "200K", hasCalculator: false },
      { name: "Mobile", slug: "mobile", population: "187K", hasCalculator: false },
    ],
    imageQuery: "Alabama state scenic landscape with rolling green hills and southern charm warm golden light pastoral countryside beautiful nature photography",
  },
  {
    name: "Alaska",
    abbreviation: "AK",
    slug: "ak",
    region: "Pacific",
    capital: "Juneau",
    population: "733K",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Anchorage", slug: "anchorage", population: "291K", hasCalculator: false },
      { name: "Fairbanks", slug: "fairbanks", population: "32K", hasCalculator: false },
      { name: "Juneau", slug: "juneau", population: "32K", hasCalculator: false },
    ],
    imageQuery: "Alaska state majestic mountain landscape with snow capped peaks glaciers and pristine wilderness northern lights aurora borealis dramatic nature",
  },
  {
    name: "Arizona",
    abbreviation: "AZ",
    slug: "az",
    region: "Southwest",
    capital: "Phoenix",
    population: "7.4M",
    stateTaxType: "Flat",
    topRate: "2.5%",
    cities: [
      { name: "Phoenix", slug: "phoenix", population: "1.6M", hasCalculator: true },
      { name: "Scottsdale", slug: "scottsdale", population: "242K", hasCalculator: true },
      { name: "Tucson", slug: "tucson", population: "543K", hasCalculator: true },
      { name: "Mesa", slug: "mesa", population: "508K", hasCalculator: true },
    ],
    imageQuery: "Arizona desert landscape with red rock formations saguaro cactus sunset warm orange tones dramatic southwestern scenery beautiful nature",
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
    slug: "ar",
    region: "Southeast",
    capital: "Little Rock",
    population: "3.0M",
    stateTaxType: "Graduated",
    topRate: "4.4%",
    cities: [
      { name: "Little Rock", slug: "little-rock", population: "202K", hasCalculator: false },
      { name: "Fayetteville", slug: "fayetteville", population: "95K", hasCalculator: false },
      { name: "Fort Smith", slug: "fort-smith", population: "89K", hasCalculator: false },
    ],
    imageQuery: "Arkansas state natural beauty with ozark mountains lush green forests crystal clear rivers and waterfalls serene peaceful landscape",
  },
  {
    name: "California",
    abbreviation: "CA",
    slug: "ca",
    region: "Pacific",
    capital: "Sacramento",
    population: "39.0M",
    stateTaxType: "Graduated",
    topRate: "12.3%",
    cities: [
      { name: "San Francisco", slug: "san-francisco", population: "874K", hasCalculator: true },
      { name: "Los Angeles", slug: "los-angeles", population: "3.9M", hasCalculator: true },
      { name: "San Diego", slug: "san-diego", population: "1.4M", hasCalculator: true },
      { name: "San Jose", slug: "san-jose", population: "1.0M", hasCalculator: true },
      { name: "Sacramento", slug: "sacramento", population: "525K", hasCalculator: true },
    ],
    imageQuery: "California golden coast landscape with pacific ocean waves palm trees and golden hills sunset warm light beautiful scenic coastline",
  },
  {
    name: "Colorado",
    abbreviation: "CO",
    slug: "co",
    region: "West",
    capital: "Denver",
    population: "5.8M",
    stateTaxType: "Flat",
    topRate: "4.4%",
    cities: [
      { name: "Denver", slug: "denver", population: "713K", hasCalculator: true },
      { name: "Colorado Springs", slug: "colorado-springs", population: "488K", hasCalculator: false },
      { name: "Aurora", slug: "aurora", population: "388K", hasCalculator: false },
      { name: "Boulder", slug: "boulder", population: "105K", hasCalculator: false },
    ],
    imageQuery: "Colorado rocky mountains landscape with snow peaks alpine meadows wildflowers clear blue sky majestic mountain scenery nature photography",
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
    slug: "ct",
    region: "Northeast",
    capital: "Hartford",
    population: "3.6M",
    stateTaxType: "Graduated",
    topRate: "6.99%",
    cities: [
      { name: "Bridgeport", slug: "bridgeport", population: "148K", hasCalculator: false },
      { name: "New Haven", slug: "new-haven", population: "135K", hasCalculator: false },
      { name: "Hartford", slug: "hartford", population: "121K", hasCalculator: false },
      { name: "Stamford", slug: "stamford", population: "135K", hasCalculator: false },
    ],
    imageQuery: "Connecticut New England autumn landscape with colorful fall foliage charming colonial towns covered bridges warm golden light scenic",
  },
  {
    name: "Delaware",
    abbreviation: "DE",
    slug: "de",
    region: "Northeast",
    capital: "Dover",
    population: "1.0M",
    stateTaxType: "Graduated",
    topRate: "6.6%",
    cities: [
      { name: "Wilmington", slug: "wilmington", population: "71K", hasCalculator: false },
      { name: "Dover", slug: "dover", population: "39K", hasCalculator: false },
      { name: "Newark", slug: "newark", population: "34K", hasCalculator: false },
    ],
    imageQuery: "Delaware coastal landscape with sandy beaches atlantic ocean shoreline historic lighthouses peaceful waterfront scenery warm sunlight",
  },
  {
    name: "Florida",
    abbreviation: "FL",
    slug: "fl",
    region: "Southeast",
    capital: "Tallahassee",
    population: "22.6M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Miami", slug: "miami", population: "442K", hasCalculator: true },
      { name: "Orlando", slug: "orlando", population: "307K", hasCalculator: true },
      { name: "Tampa", slug: "tampa", population: "387K", hasCalculator: true },
      { name: "Jacksonville", slug: "jacksonville", population: "950K", hasCalculator: true },
      { name: "Fort Lauderdale", slug: "fort-lauderdale", population: "183K", hasCalculator: false },
    ],
    imageQuery: "Florida tropical beach landscape with turquoise ocean water palm trees white sand warm sunset light beautiful coastal paradise scenery",
  },
  {
    name: "Georgia",
    abbreviation: "GA",
    slug: "ga",
    region: "Southeast",
    capital: "Atlanta",
    population: "11.0M",
    stateTaxType: "Graduated",
    topRate: "5.5%",
    cities: [
      { name: "Atlanta", slug: "atlanta", population: "499K", hasCalculator: true },
      { name: "Savannah", slug: "savannah", population: "147K", hasCalculator: false },
      { name: "Augusta", slug: "augusta", population: "202K", hasCalculator: false },
      { name: "Columbus", slug: "columbus", population: "206K", hasCalculator: false },
    ],
    imageQuery: "Georgia state landscape with spanish moss draped oak trees southern plantation style warm golden sunlight peaceful countryside scenery",
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
    slug: "hi",
    region: "Pacific",
    capital: "Honolulu",
    population: "1.4M",
    stateTaxType: "Graduated",
    topRate: "11.0%",
    cities: [
      { name: "Honolulu", slug: "honolulu", population: "350K", hasCalculator: true },
      { name: "Hilo", slug: "hilo", population: "46K", hasCalculator: false },
      { name: "Kailua", slug: "kailua", population: "40K", hasCalculator: false },
    ],
    imageQuery: "Hawaii tropical island landscape with volcanic mountains lush green valleys turquoise ocean waves beautiful paradise beach scenery",
  },
  {
    name: "Idaho",
    abbreviation: "ID",
    slug: "id",
    region: "West",
    capital: "Boise",
    population: "1.9M",
    stateTaxType: "Flat",
    topRate: "5.8%",
    cities: [
      { name: "Boise", slug: "boise", population: "236K", hasCalculator: true },
      { name: "Meridian", slug: "meridian", population: "130K", hasCalculator: false },
      { name: "Nampa", slug: "nampa", population: "108K", hasCalculator: false },
    ],
    imageQuery: "Idaho state landscape with rugged mountain terrain pristine rivers and forests dramatic wilderness scenery clear blue sky nature",
  },
  {
    name: "Illinois",
    abbreviation: "IL",
    slug: "il",
    region: "Midwest",
    capital: "Springfield",
    population: "12.5M",
    stateTaxType: "Flat",
    topRate: "4.95%",
    cities: [
      { name: "Chicago", slug: "chicago", population: "2.7M", hasCalculator: true },
      { name: "Aurora", slug: "aurora", population: "180K", hasCalculator: false },
      { name: "Naperville", slug: "naperville", population: "149K", hasCalculator: false },
      { name: "Springfield", slug: "springfield", population: "114K", hasCalculator: false },
    ],
    imageQuery: "Illinois prairie landscape with vast golden wheat fields under dramatic sky midwestern farmland beautiful warm sunset light scenic",
  },
  {
    name: "Indiana",
    abbreviation: "IN",
    slug: "in",
    region: "Midwest",
    capital: "Indianapolis",
    population: "6.8M",
    stateTaxType: "Flat",
    topRate: "3.05%",
    cities: [
      { name: "Indianapolis", slug: "indianapolis", population: "887K", hasCalculator: true },
      { name: "Fort Wayne", slug: "fort-wayne", population: "264K", hasCalculator: false },
      { name: "Evansville", slug: "evansville", population: "117K", hasCalculator: false },
    ],
    imageQuery: "Indiana state landscape with rolling farmland cornfields red barns peaceful midwestern countryside warm golden hour light scenic",
  },
  {
    name: "Iowa",
    abbreviation: "IA",
    slug: "ia",
    region: "Midwest",
    capital: "Des Moines",
    population: "3.2M",
    stateTaxType: "Flat",
    topRate: "3.8%",
    cities: [
      { name: "Des Moines", slug: "des-moines", population: "214K", hasCalculator: false },
      { name: "Cedar Rapids", slug: "cedar-rapids", population: "137K", hasCalculator: false },
      { name: "Davenport", slug: "davenport", population: "101K", hasCalculator: false },
    ],
    imageQuery: "Iowa state landscape with endless green cornfields rolling hills peaceful farmland warm summer light beautiful midwestern scenery",
  },
  {
    name: "Kansas",
    abbreviation: "KS",
    slug: "ks",
    region: "Midwest",
    capital: "Topeka",
    population: "2.9M",
    stateTaxType: "Graduated",
    topRate: "5.7%",
    cities: [
      { name: "Wichita", slug: "wichita", population: "397K", hasCalculator: false },
      { name: "Overland Park", slug: "overland-park", population: "197K", hasCalculator: false },
      { name: "Kansas City", slug: "kansas-city", population: "156K", hasCalculator: false },
      { name: "Topeka", slug: "topeka", population: "127K", hasCalculator: false },
    ],
    imageQuery: "Kansas state landscape with vast golden wheat fields stretching to horizon dramatic sunset sky beautiful plains scenery nature",
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
    slug: "ky",
    region: "Southeast",
    capital: "Frankfort",
    population: "4.5M",
    stateTaxType: "Flat",
    topRate: "4.0%",
    cities: [
      { name: "Louisville", slug: "louisville", population: "633K", hasCalculator: true },
      { name: "Lexington", slug: "lexington", population: "323K", hasCalculator: true },
      { name: "Bowling Green", slug: "bowling-green", population: "78K", hasCalculator: false },
    ],
    imageQuery: "Kentucky state landscape with lush green horse farms white fences rolling bluegrass hills warm golden sunlight beautiful countryside",
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
    slug: "la",
    region: "Southeast",
    capital: "Baton Rouge",
    population: "4.6M",
    stateTaxType: "Graduated",
    topRate: "4.25%",
    cities: [
      { name: "New Orleans", slug: "new-orleans", population: "383K", hasCalculator: true },
      { name: "Baton Rouge", slug: "baton-rouge", population: "227K", hasCalculator: true },
      { name: "Shreveport", slug: "shreveport", population: "188K", hasCalculator: false },
    ],
    imageQuery: "Louisiana bayou landscape with cypress trees draped in spanish moss swamp waterways warm golden light southern atmosphere scenic",
  },
  {
    name: "Maine",
    abbreviation: "ME",
    slug: "me",
    region: "Northeast",
    capital: "Augusta",
    population: "1.4M",
    stateTaxType: "Graduated",
    topRate: "7.15%",
    cities: [
      { name: "Portland", slug: "portland", population: "68K", hasCalculator: false },
      { name: "Lewiston", slug: "lewiston", population: "37K", hasCalculator: false },
      { name: "Bangor", slug: "bangor", population: "32K", hasCalculator: false },
    ],
    imageQuery: "Maine state rocky coastline landscape with lighthouse crashing ocean waves pine forests dramatic New England seascape beautiful nature",
  },
  {
    name: "Maryland",
    abbreviation: "MD",
    slug: "md",
    region: "Northeast",
    capital: "Annapolis",
    population: "6.2M",
    stateTaxType: "Graduated",
    topRate: "5.75%",
    cities: [
      { name: "Baltimore", slug: "baltimore", population: "576K", hasCalculator: true },
      { name: "Columbia", slug: "columbia", population: "104K", hasCalculator: false },
      { name: "Silver Spring", slug: "silver-spring", population: "81K", hasCalculator: false },
      { name: "Annapolis", slug: "annapolis", population: "40K", hasCalculator: false },
    ],
    imageQuery: "Maryland Chesapeake Bay landscape with waterfront harbor sailboats historic colonial architecture warm sunset light beautiful coastal scenery",
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
    slug: "ma",
    region: "Northeast",
    capital: "Boston",
    population: "7.0M",
    stateTaxType: "Flat",
    topRate: "5.0%",
    cities: [
      { name: "Boston", slug: "boston", population: "675K", hasCalculator: true },
      { name: "Cambridge", slug: "cambridge", population: "118K", hasCalculator: true },
      { name: "Worcester", slug: "worcester", population: "206K", hasCalculator: false },
      { name: "Springfield", slug: "springfield", population: "155K", hasCalculator: false },
    ],
    imageQuery: "Massachusetts New England landscape with historic brick buildings autumn foliage harbor waterfront charming colonial architecture warm light scenic",
  },
  {
    name: "Michigan",
    abbreviation: "MI",
    slug: "mi",
    region: "Midwest",
    capital: "Lansing",
    population: "10.0M",
    stateTaxType: "Flat",
    topRate: "4.25%",
    cities: [
      { name: "Detroit", slug: "detroit", population: "639K", hasCalculator: true },
      { name: "Grand Rapids", slug: "grand-rapids", population: "198K", hasCalculator: true },
      { name: "Ann Arbor", slug: "ann-arbor", population: "123K", hasCalculator: true },
      { name: "Lansing", slug: "lansing", population: "112K", hasCalculator: false },
    ],
    imageQuery: "Michigan Great Lakes landscape with pristine lakeshore sand dunes autumn forest colorful foliage beautiful waterfront nature scenery",
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
    slug: "mn",
    region: "Midwest",
    capital: "Saint Paul",
    population: "5.7M",
    stateTaxType: "Graduated",
    topRate: "9.85%",
    cities: [
      { name: "Minneapolis", slug: "minneapolis", population: "429K", hasCalculator: true },
      { name: "Saint Paul", slug: "saint-paul", population: "311K", hasCalculator: true },
      { name: "Rochester", slug: "rochester", population: "121K", hasCalculator: false },
      { name: "Duluth", slug: "duluth", population: "91K", hasCalculator: false },
    ],
    imageQuery: "Minnesota land of ten thousand lakes landscape with pristine lake reflections pine forests northern wilderness beautiful nature scenery",
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
    slug: "ms",
    region: "Southeast",
    capital: "Jackson",
    population: "2.9M",
    stateTaxType: "Graduated",
    topRate: "5.0%",
    cities: [
      { name: "Jackson", slug: "jackson", population: "153K", hasCalculator: false },
      { name: "Gulfport", slug: "gulfport", population: "72K", hasCalculator: false },
      { name: "Hattiesburg", slug: "hattiesburg", population: "48K", hasCalculator: false },
    ],
    imageQuery: "Mississippi river delta landscape with winding waterways lush green vegetation southern wetlands warm golden sunset light scenic",
  },
  {
    name: "Missouri",
    abbreviation: "MO",
    slug: "mo",
    region: "Midwest",
    capital: "Jefferson City",
    population: "6.2M",
    stateTaxType: "Graduated",
    topRate: "4.95%",
    cities: [
      { name: "Kansas City", slug: "kansas-city", population: "508K", hasCalculator: true },
      { name: "St. Louis", slug: "st-louis", population: "293K", hasCalculator: true },
      { name: "Springfield", slug: "springfield", population: "169K", hasCalculator: false },
      { name: "Columbia", slug: "columbia", population: "126K", hasCalculator: false },
    ],
    imageQuery: "Missouri state landscape with rolling ozark hills gateway arch silhouette river valleys warm autumn colors beautiful scenic nature",
  },
  {
    name: "Montana",
    abbreviation: "MT",
    slug: "mt",
    region: "West",
    capital: "Helena",
    population: "1.1M",
    stateTaxType: "Graduated",
    topRate: "5.9%",
    cities: [
      { name: "Billings", slug: "billings", population: "119K", hasCalculator: false },
      { name: "Missoula", slug: "missoula", population: "75K", hasCalculator: false },
      { name: "Great Falls", slug: "great-falls", population: "60K", hasCalculator: false },
    ],
    imageQuery: "Montana big sky country landscape with vast open plains dramatic mountain ranges pristine wilderness beautiful nature photography scenic",
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
    slug: "ne",
    region: "Midwest",
    capital: "Lincoln",
    population: "2.0M",
    stateTaxType: "Graduated",
    topRate: "5.84%",
    cities: [
      { name: "Omaha", slug: "omaha", population: "487K", hasCalculator: true },
      { name: "Lincoln", slug: "lincoln", population: "292K", hasCalculator: false },
      { name: "Bellevue", slug: "bellevue", population: "64K", hasCalculator: false },
    ],
    imageQuery: "Nebraska state landscape with vast golden prairie grasslands rolling sandhills dramatic sunset sky beautiful plains nature scenery",
  },
  {
    name: "Nevada",
    abbreviation: "NV",
    slug: "nv",
    region: "West",
    capital: "Carson City",
    population: "3.2M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Las Vegas", slug: "las-vegas", population: "646K", hasCalculator: true },
      { name: "Henderson", slug: "henderson", population: "320K", hasCalculator: true },
      { name: "Reno", slug: "reno", population: "264K", hasCalculator: true },
    ],
    imageQuery: "Nevada desert landscape with red rock canyon formations dramatic desert scenery warm sunset tones beautiful arid wilderness nature",
  },
  {
    name: "New Hampshire",
    abbreviation: "NH",
    slug: "nh",
    region: "Northeast",
    capital: "Concord",
    population: "1.4M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Manchester", slug: "manchester", population: "115K", hasCalculator: false },
      { name: "Nashua", slug: "nashua", population: "91K", hasCalculator: false },
      { name: "Concord", slug: "concord", population: "44K", hasCalculator: false },
    ],
    imageQuery: "New Hampshire White Mountains landscape with autumn foliage covered bridges pristine lakes beautiful New England fall scenery nature",
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
    slug: "nj",
    region: "Northeast",
    capital: "Trenton",
    population: "9.3M",
    stateTaxType: "Graduated",
    topRate: "10.75%",
    cities: [
      { name: "Jersey City", slug: "jersey-city", population: "283K", hasCalculator: true },
      { name: "Newark", slug: "newark", population: "311K", hasCalculator: true },
      { name: "Hackensack", slug: "hackensack", population: "46K", hasCalculator: true },
      { name: "Wood-Ridge", slug: "wood-ridge", population: "10K", hasCalculator: true },
    ],
    imageQuery: "New Jersey shore landscape with sandy beaches boardwalk atlantic ocean waves lighthouse warm summer light beautiful coastal scenery",
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
    slug: "nm",
    region: "Southwest",
    capital: "Santa Fe",
    population: "2.1M",
    stateTaxType: "Graduated",
    topRate: "5.9%",
    cities: [
      { name: "Albuquerque", slug: "albuquerque", population: "564K", hasCalculator: true },
      { name: "Las Cruces", slug: "las-cruces", population: "111K", hasCalculator: false },
      { name: "Santa Fe", slug: "santa-fe", population: "88K", hasCalculator: true },
    ],
    imageQuery: "New Mexico desert landscape with adobe architecture dramatic mesas sunset warm terracotta tones beautiful southwestern scenery nature",
  },
  {
    name: "New York",
    abbreviation: "NY",
    slug: "ny",
    region: "Northeast",
    capital: "Albany",
    population: "19.5M",
    stateTaxType: "Graduated",
    topRate: "10.9%",
    cities: [
      { name: "Manhattan", slug: "manhattan", population: "1.6M", hasCalculator: true },
      { name: "Brooklyn", slug: "brooklyn", population: "2.6M", hasCalculator: true },
      { name: "Buffalo", slug: "buffalo", population: "278K", hasCalculator: true },
      { name: "Albany", slug: "albany", population: "99K", hasCalculator: false },
      { name: "Rochester", slug: "rochester", population: "211K", hasCalculator: false },
    ],
    imageQuery: "New York state landscape with hudson valley autumn foliage adirondack mountains scenic waterways beautiful fall colors nature photography",
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
    slug: "nc",
    region: "Southeast",
    capital: "Raleigh",
    population: "10.7M",
    stateTaxType: "Flat",
    topRate: "4.75%",
    cities: [
      { name: "Charlotte", slug: "charlotte", population: "874K", hasCalculator: true },
      { name: "Raleigh", slug: "raleigh", population: "467K", hasCalculator: true },
      { name: "Durham", slug: "durham", population: "283K", hasCalculator: false },
      { name: "Greensboro", slug: "greensboro", population: "299K", hasCalculator: false },
    ],
    imageQuery: "North Carolina blue ridge mountains landscape with misty peaks autumn foliage scenic parkway beautiful appalachian nature scenery",
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
    slug: "nd",
    region: "Midwest",
    capital: "Bismarck",
    population: "779K",
    stateTaxType: "Flat",
    topRate: "1.95%",
    cities: [
      { name: "Fargo", slug: "fargo", population: "125K", hasCalculator: false },
      { name: "Bismarck", slug: "bismarck", population: "74K", hasCalculator: false },
      { name: "Grand Forks", slug: "grand-forks", population: "56K", hasCalculator: false },
    ],
    imageQuery: "North Dakota badlands landscape with dramatic rock formations vast prairie grasslands golden sunset light beautiful wilderness scenery",
  },
  {
    name: "Ohio",
    abbreviation: "OH",
    slug: "oh",
    region: "Midwest",
    capital: "Columbus",
    population: "11.8M",
    stateTaxType: "Graduated",
    topRate: "3.5%",
    cities: [
      { name: "Columbus", slug: "columbus", population: "906K", hasCalculator: true },
      { name: "Cleveland", slug: "cleveland", population: "372K", hasCalculator: true },
      { name: "Cincinnati", slug: "cincinnati", population: "309K", hasCalculator: true },
      { name: "Toledo", slug: "toledo", population: "270K", hasCalculator: false },
    ],
    imageQuery: "Ohio state landscape with rolling green farmland river valleys autumn foliage charming small towns beautiful midwestern scenery nature",
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
    slug: "ok",
    region: "Southwest",
    capital: "Oklahoma City",
    population: "4.0M",
    stateTaxType: "Graduated",
    topRate: "4.75%",
    cities: [
      { name: "Oklahoma City", slug: "oklahoma-city", population: "681K", hasCalculator: true },
      { name: "Tulsa", slug: "tulsa", population: "413K", hasCalculator: true },
      { name: "Norman", slug: "norman", population: "128K", hasCalculator: false },
    ],
    imageQuery: "Oklahoma state landscape with vast open plains dramatic thunderstorm sky golden wheat fields beautiful great plains scenery nature",
  },
  {
    name: "Oregon",
    abbreviation: "OR",
    slug: "or",
    region: "Pacific",
    capital: "Salem",
    population: "4.2M",
    stateTaxType: "Graduated",
    topRate: "9.9%",
    cities: [
      { name: "Portland", slug: "portland", population: "652K", hasCalculator: true },
      { name: "Salem", slug: "salem", population: "175K", hasCalculator: true },
      { name: "Eugene", slug: "eugene", population: "176K", hasCalculator: true },
      { name: "Bend", slug: "bend", population: "102K", hasCalculator: false },
    ],
    imageQuery: "Oregon state landscape with lush green pacific northwest forests crater lake mountains dramatic coastline beautiful nature scenery",
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
    slug: "pa",
    region: "Northeast",
    capital: "Harrisburg",
    population: "13.0M",
    stateTaxType: "Flat",
    topRate: "3.07%",
    cities: [
      { name: "Philadelphia", slug: "philadelphia", population: "1.6M", hasCalculator: true },
      { name: "Pittsburgh", slug: "pittsburgh", population: "302K", hasCalculator: true },
      { name: "Allentown", slug: "allentown", population: "126K", hasCalculator: false },
      { name: "Harrisburg", slug: "harrisburg", population: "50K", hasCalculator: false },
    ],
    imageQuery: "Pennsylvania state landscape with appalachian mountains autumn foliage historic covered bridges charming countryside beautiful fall scenery",
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
    slug: "ri",
    region: "Northeast",
    capital: "Providence",
    population: "1.1M",
    stateTaxType: "Graduated",
    topRate: "5.99%",
    cities: [
      { name: "Providence", slug: "providence", population: "190K", hasCalculator: false },
      { name: "Warwick", slug: "warwick", population: "82K", hasCalculator: false },
      { name: "Cranston", slug: "cranston", population: "82K", hasCalculator: false },
    ],
    imageQuery: "Rhode Island coastal landscape with newport mansions rocky shoreline sailboats harbor beautiful New England waterfront scenery nature",
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
    slug: "sc",
    region: "Southeast",
    capital: "Columbia",
    population: "5.3M",
    stateTaxType: "Graduated",
    topRate: "6.4%",
    cities: [
      { name: "Charleston", slug: "charleston", population: "150K", hasCalculator: true },
      { name: "Columbia", slug: "columbia", population: "137K", hasCalculator: true },
      { name: "Greenville", slug: "greenville", population: "72K", hasCalculator: false },
      { name: "Myrtle Beach", slug: "myrtle-beach", population: "35K", hasCalculator: false },
    ],
    imageQuery: "South Carolina lowcountry landscape with spanish moss oak trees historic charleston architecture warm golden light beautiful southern scenery",
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
    slug: "sd",
    region: "Midwest",
    capital: "Pierre",
    population: "909K",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Sioux Falls", slug: "sioux-falls", population: "192K", hasCalculator: false },
      { name: "Rapid City", slug: "rapid-city", population: "77K", hasCalculator: false },
      { name: "Aberdeen", slug: "aberdeen", population: "28K", hasCalculator: false },
    ],
    imageQuery: "South Dakota badlands landscape with dramatic rock spires vast prairie mount rushmore region beautiful wilderness nature scenery",
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
    slug: "tn",
    region: "Southeast",
    capital: "Nashville",
    population: "7.1M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Nashville", slug: "nashville", population: "689K", hasCalculator: true },
      { name: "Memphis", slug: "memphis", population: "633K", hasCalculator: true },
      { name: "Knoxville", slug: "knoxville", population: "190K", hasCalculator: false },
      { name: "Chattanooga", slug: "chattanooga", population: "181K", hasCalculator: true },
    ],
    imageQuery: "Tennessee great smoky mountains landscape with misty peaks autumn foliage rolling hills beautiful appalachian nature scenery warm light",
  },
  {
    name: "Texas",
    abbreviation: "TX",
    slug: "tx",
    region: "Southwest",
    capital: "Austin",
    population: "30.5M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Austin", slug: "austin", population: "979K", hasCalculator: true },
      { name: "Houston", slug: "houston", population: "2.3M", hasCalculator: true },
      { name: "Dallas", slug: "dallas", population: "1.3M", hasCalculator: true },
      { name: "San Antonio", slug: "san-antonio", population: "1.5M", hasCalculator: true },
      { name: "Fort Worth", slug: "fort-worth", population: "958K", hasCalculator: true },
    ],
    imageQuery: "Texas hill country landscape with wildflowers bluebonnets rolling green hills warm sunset light beautiful southwestern nature scenery",
  },
  {
    name: "Utah",
    abbreviation: "UT",
    slug: "ut",
    region: "West",
    capital: "Salt Lake City",
    population: "3.4M",
    stateTaxType: "Flat",
    topRate: "4.65%",
    cities: [
      { name: "Salt Lake City", slug: "salt-lake-city", population: "200K", hasCalculator: true },
      { name: "West Valley City", slug: "west-valley-city", population: "140K", hasCalculator: false },
      { name: "Provo", slug: "provo", population: "115K", hasCalculator: true },
    ],
    imageQuery: "Utah state landscape with dramatic red rock arches canyon formations snow capped mountains beautiful desert wilderness nature scenery",
  },
  {
    name: "Vermont",
    abbreviation: "VT",
    slug: "vt",
    region: "Northeast",
    capital: "Montpelier",
    population: "647K",
    stateTaxType: "Graduated",
    topRate: "8.75%",
    cities: [
      { name: "Burlington", slug: "burlington", population: "45K", hasCalculator: false },
      { name: "South Burlington", slug: "south-burlington", population: "20K", hasCalculator: false },
      { name: "Rutland", slug: "rutland", population: "15K", hasCalculator: false },
    ],
    imageQuery: "Vermont state landscape with green mountains autumn foliage covered bridges charming villages beautiful New England fall scenery nature",
  },
  {
    name: "Virginia",
    abbreviation: "VA",
    slug: "va",
    region: "Southeast",
    capital: "Richmond",
    population: "8.6M",
    stateTaxType: "Graduated",
    topRate: "5.75%",
    cities: [
      { name: "Virginia Beach", slug: "virginia-beach", population: "459K", hasCalculator: true },
      { name: "Norfolk", slug: "norfolk", population: "238K", hasCalculator: false },
      { name: "Richmond", slug: "richmond", population: "226K", hasCalculator: true },
      { name: "Arlington", slug: "arlington", population: "238K", hasCalculator: true },
    ],
    imageQuery: "Virginia state landscape with shenandoah valley blue ridge mountains autumn foliage historic colonial architecture beautiful nature scenery",
  },
  {
    name: "Washington",
    abbreviation: "WA",
    slug: "wa",
    region: "Pacific",
    capital: "Olympia",
    population: "7.8M",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Seattle", slug: "seattle", population: "737K", hasCalculator: true },
      { name: "Spokane", slug: "spokane", population: "228K", hasCalculator: false },
      { name: "Tacoma", slug: "tacoma", population: "219K", hasCalculator: false },
      { name: "Bellevue", slug: "bellevue", population: "151K", hasCalculator: false },
    ],
    imageQuery: "Washington state landscape with mount rainier snow peak evergreen forests pacific northwest lush green scenery beautiful nature",
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
    slug: "wv",
    region: "Southeast",
    capital: "Charleston",
    population: "1.8M",
    stateTaxType: "Graduated",
    topRate: "5.12%",
    cities: [
      { name: "Charleston", slug: "charleston", population: "48K", hasCalculator: false },
      { name: "Huntington", slug: "huntington", population: "46K", hasCalculator: false },
      { name: "Morgantown", slug: "morgantown", population: "31K", hasCalculator: false },
    ],
    imageQuery: "West Virginia appalachian mountains landscape with lush green valleys winding rivers autumn foliage beautiful mountain scenery nature",
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
    slug: "wi",
    region: "Midwest",
    capital: "Madison",
    population: "5.9M",
    stateTaxType: "Graduated",
    topRate: "7.65%",
    cities: [
      { name: "Milwaukee", slug: "milwaukee", population: "577K", hasCalculator: true },
      { name: "Madison", slug: "madison", population: "269K", hasCalculator: true },
      { name: "Green Bay", slug: "green-bay", population: "107K", hasCalculator: false },
    ],
    imageQuery: "Wisconsin state landscape with pristine lakes dairy farmland rolling green hills charming small towns beautiful midwestern nature scenery",
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
    slug: "wy",
    region: "West",
    capital: "Cheyenne",
    population: "577K",
    stateTaxType: "None",
    topRate: "0%",
    cities: [
      { name: "Cheyenne", slug: "cheyenne", population: "65K", hasCalculator: false },
      { name: "Casper", slug: "casper", population: "59K", hasCalculator: false },
      { name: "Laramie", slug: "laramie", population: "32K", hasCalculator: false },
    ],
    imageQuery: "Wyoming state landscape with grand teton mountains yellowstone geysers vast open range beautiful dramatic wilderness nature scenery",
  },
  {
    name: "District of Columbia",
    abbreviation: "DC",
    slug: "dc",
    region: "Northeast",
    capital: "Washington",
    population: "689K",
    stateTaxType: "Graduated",
    topRate: "10.75%",
    cities: [
      { name: "Washington DC", slug: "washington-dc", population: "689K", hasCalculator: true },
      { name: "Georgetown", slug: "georgetown", population: "12K", hasCalculator: false },
      { name: "Capitol Hill", slug: "capitol-hill", population: "35K", hasCalculator: false },
    ],
    imageQuery: "Washington DC landscape with national mall monuments cherry blossoms reflecting pool beautiful capital city scenery warm light",
  },
  {
    name: "Puerto Rico",
    abbreviation: "PR",
    slug: "pr",
    region: "Southeast",
    capital: "San Juan",
    population: "3.2M",
    stateTaxType: "Graduated",
    topRate: "33.0%",
    cities: [
      { name: "San Juan", slug: "san-juan", population: "342K", hasCalculator: false },
      { name: "Bayamon", slug: "bayamon", population: "185K", hasCalculator: false },
      { name: "Ponce", slug: "ponce", population: "132K", hasCalculator: false },
    ],
    imageQuery: "Puerto Rico tropical landscape with colorful colonial buildings turquoise caribbean ocean palm trees beautiful island paradise scenery",
  },
];
